// /opt/isp_erp/frontend/src/api/sla.api.js
import axios from './axios';

export const slaAPI = {
  // Obtener todas las configuraciones
  getAll: async () => {
    const response = await axios.get('/sla-configs/');  // ← Sin /api/v1
    return response.data;
  },

  // Obtener una configuración por ID
  getById: async (id) => {
    const response = await axios.get(`/sla-configs/${id}`);  // ← Sin /api/v1
    return response.data;
  },

  // Crear nueva configuración
  create: async (data) => {
    const response = await axios.post('/sla-configs/', data);  // ← Sin /api/v1
    return response.data;
  },

  // Actualizar configuración
  update: async (id, data) => {
    const response = await axios.put(`/sla-configs/${id}`, data);  // ← Sin /api/v1
    return response.data;
  },

  // Eliminar configuración
  delete: async (id) => {
    const response = await axios.delete(`/sla-configs/${id}`);  // ← Sin /api/v1
    return response.data;
  },

  // Inicializar configuraciones por defecto
  initialize: async () => {
    const response = await axios.post('/sla-configs/initialize');  // ← Sin /api/v1
    return response.data;
  },

  // Obtener valores por defecto
  getDefaults: async () => {
    const response = await axios.get('/sla-configs/defaults');  // ← Sin /api/v1
    return response.data;
  }
};
